export const aimTagClient = (host: string, dataLayerName = "aimDataLayer") => {
    return `${host}/js/client.js?dl=${dataLayerName}`;
};
